<template>
  <div class="rr-page public_Spacing">

    <!-- 页面头部 -->
    <div class="rr-header">
      <div class="rr-header-left">
        <div class="rr-header-icon"><i class="iconfont icon-caiwu" style="font-size:22px;color:#409EFF;"></i></div>
        <div>
          <div class="rr-header-title">银企交易流水</div>
          <div class="rr-header-desc">银企直连打款记录，对未自动充值的交易进行人工审核充值或驳回</div>
        </div>
      </div>
      <div class="rr-header-stats">
        <div class="rr-stat-item">
          <span class="rr-stat-num">{{ total }}</span>
          <span class="rr-stat-label">共计</span>
        </div>
        <div class="rr-stat-item rr-stat-pending">
          <span class="rr-stat-num">{{ tableData.filter(r => r.ORMTB433CA13 == '0').length }}</span>
          <span class="rr-stat-label">待审核</span>
        </div>
      </div>
    </div>

    <!-- 筛选条件区 -->
    <div class="pulbic_oparetionBlock rr-filter-card">
      <div class="rr-filter-head">
        <span class="rr-filter-title">筛选条件</span>
        <span class="rr-filter-desc">支持按交易日期、客户、付款人名称、识别码、状态组合筛选</span>
      </div>
      <div class="public_criteriaRange">
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">交易日期：</label>
          <date-range-picker
            ref="dateRangePicker"
            v-model="dateRange"
            label="快捷时间"
            default-shortcut="nowDay"
          ></date-range-picker>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">付款人名称：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <input
                class="el-input__inner"
                type="text"
                placeholder="请输入付款人名称"
                v-model="queryParams.ORMTB433CA04"
                @keyup.enter="queryClick"
              />
            </div>
          </div>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">识别码：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <input
                class="el-input__inner"
                type="text"
                placeholder="请输入识别码"
                v-model="queryParams.ORMTB433CA12"
                @keyup.enter="queryClick"
              />
            </div>
          </div>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">客户：</label>
          <el-select
            class="public_optionSty rr-customer-filter-select"
            v-model="queryParams.ORMTB410ID"
            filterable
            clearable
            remote
            :remote-method="filterQueryCustomer"
            placeholder="可输入客户名称、手机号或拼音检索"
            size="small"
          >
            <el-option
              v-for="item in filteredQueryCustomerOptions"
              :key="item.ORMTB410ID"
              :label="customerOptionLabel(item)"
              :value="item.ORMTB410ID"
            >
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span style="font-size: 14px; font-weight: 600; color: #303133;">{{ item.ORMTB410CA00 || item.ORMTB410NAME }}</span>
                <span style="color: #409EFF; font-size: 13px; font-weight: 500; margin-left: 12px;">{{ item.ORMTB410CA02 || item.ORMTB410CA13 }}</span>
              </div>
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">状态：</label>
          <el-select class="public_optionSty" v-model="queryParams.ORMTB433CA13" clearable placeholder="请选择状态" size="small">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div class="public_operatBtn" style="margin-left: 0; margin-top: 12px;">
        <el-button class="public_saleWater_chaxun" type="primary" size="small" @click="queryClick">
          <i class="iconfont icon-chaxun"></i>查询
        </el-button>
        <el-button type="info" plain size="small" @click="resetQuery">重置</el-button>
        <el-button class="public_saleWater_daochu pulic_cursor" :loading="loadingBut" size="small" @click="exportExcel">
          <i class="iconfont icon-daochu"></i>导出<span v-if="confirmTxt > 0">{{ confirmTxt }}</span>
        </el-button>
      </div>
    </div>

    <!-- 表格区 -->
    <div class="pulbic_oparetionBlock pulbic_table_container rr-table-card">
      <div class="rr-table-head">
        <div class="rr-table-title-row">
          <div>
            <div class="rr-table-title">交易流水列表</div>
            <div class="rr-table-subtitle">共 {{ total }} 条记录，当前页 {{ tableData.length }} 条；点击流水号可查看详情</div>
          </div>
        </div>
        <div class="rr-status-legend">
          <span><i class="rr-dot rr-dot-pending"></i>未处理</span>
          <span><i class="rr-dot rr-dot-done"></i>已处理</span>
          <span><i class="rr-dot rr-dot-reject"></i>已驳回</span>
        </div>
      </div>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        class="public_tableColumn"
        :header-cell-style="{
          color: 'rgba(51,51,51,1)',
          background: 'rgba(184,227,255,1)',
          'font-weight': 'bold',
          'text-align': 'center',
        }"
      >
        <el-table-column label="流水号/交易时间" width="200" align="center">
          <template slot-scope="scope">
            <el-tooltip content="点击查看详情" placement="top">
              <div class="rr-serial-no" @click="openDetailModal(scope.row)">{{ scope.row.ORMTB433CA00 }}</div>
            </el-tooltip>
            <div class="rr-trade-time">{{ scope.row.ORMTB433CA02 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="客户名称/手机号" align="center" min-width="130">
          <template slot-scope="scope">
            <template v-if="scope.row.ORMTB433CA14 || scope.row.ORMTB433CA15">
              <div class="rr-customer-name">{{ scope.row.ORMTB433CA14 || '未匹配客户名称' }}</div>
              <div class="rr-customer-phone">{{ scope.row.ORMTB433CA15 || '未匹配手机号' }}</div>
            </template>
            <div v-else class="rr-customer-empty">未匹配客户</div>
          </template>
        </el-table-column>
        <el-table-column prop="ORMTB433CA04" label="付款人名称" min-width="130" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ORMTB433CA05" label="交易金额(元)" width="130" align="center">
          <template slot-scope="scope">
            <span class="rr-amount">¥ {{ formatAmount(scope.row.ORMTB433CA05) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ORMTB433CA12" label="识别码" width="140" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ORMTB433CA13" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.ORMTB433CA13)" size="small" effect="light">
              {{ statusLabel(scope.row.ORMTB433CA13) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.ORMTB433CA13 == '0'">
              <el-button type="primary" size="small" @click="openConfirmModal(scope.row)">审核充值</el-button>
              <el-button type="danger" size="small" plain style="margin-left: 16px;" @click="openRejectModal(scope.row)">驳回</el-button>
            </template>
            <span v-else class="rr-processed-tip">
              {{ scope.row.ORMTB433CA13 == '1' ? '已完成' : '已驳回' }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="queryParams.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 审核充值弹窗 -->
    <div class="public-dialog">
      <el-dialog
        title="审核充值 - 确认已收到打款"
        :visible.sync="confirmModal.visible"
        width="500px"
        :closeOnClickModal="false"
        append-to-body
        @close="confirmModalClose"
      >
        <div class="recharge-info-box">
          <div class="rr-info-section-title">交易信息</div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">流水号：</span>
            <span class="recharge-info-value">{{ confirmModal.row.ORMTB433CA00 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">交易时间：</span>
            <span class="recharge-info-value">{{ confirmModal.row.ORMTB433CA02 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">付款人名称：</span>
            <span class="recharge-info-value">{{ confirmModal.row.ORMTB433CA04 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">付款人账号：</span>
            <span class="recharge-info-value">{{ confirmModal.row.ORMTB433CA03 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">交易金额：</span>
            <span class="recharge-info-value" style="color: #f56c6c; font-weight: bold; font-size: 16px;">
              {{ formatAmount(confirmModal.row.ORMTB433CA05) }}
            </span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">识别码：</span>
            <span class="recharge-info-value">{{ confirmModal.row.ORMTB433CA12 }}</span>
          </div>
          <div class="rr-info-section-title rr-info-section-title-receive">收款信息</div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">收款户名：</span>
            <span class="recharge-info-value">{{ confirmModal.row.ORMTB433CA11 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">收款账号：</span>
            <span class="recharge-info-value">{{ confirmModal.row.ORMTB433CA10 }}</span>
          </div>
        </div>
        <div class="recharge-customer-box">
          <div class="recharge-info-label" style="margin-bottom: 8px;">充值客户<span style="color: #f56c6c;">*</span>：</div>
          <el-select
            v-model="confirmModal.customerId"
            filterable
            clearable
            remote
            :remote-method="filterRechargeCustomer"
            placeholder="可输入客户名称、手机号或拼音检索"
            style="width: 100%;"
          >
            <el-option
              v-for="item in filteredRechargeCustomerOptions"
              :key="item.ORMTB410ID"
              :label="customerOptionLabel(item)"
              :value="item.ORMTB410ID"
            >
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span style="font-size: 14px; font-weight: 600; color: #303133;">{{ item.ORMTB410CA00 || item.ORMTB410NAME }}</span>
                <span style="color: #409EFF; font-size: 13px; font-weight: 500; margin-left: 12px;">{{ item.ORMTB410CA02 || item.ORMTB410CA13 }}</span>
              </div>
            </el-option>
          </el-select>
          <div class="recharge-customer-tip"><i class="el-icon-info"></i> 支持按客户名称、手机号、客户拼音检索</div>
        </div>
        <div class="recharge-remark-box">
          <div class="rr-remark-title">财务备注（可选）：</div>
          <el-input
            v-model="confirmModal.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入财务备注，如：已确认银行账单，金额一致"
            maxlength="200"
            show-word-limit
          ></el-input>
        </div>
        <span slot="footer">
          <el-tooltip content="取消操作，不进行充值" placement="top">
            <el-button class="rr-btn-cancel" @click="confirmModal.visible = false">取消</el-button>
          </el-tooltip>
          <el-tooltip content="确认已收到打款，将为客户充值" placement="top">
            <el-button type="primary" :loading="confirmModal.loading" class="rr-btn-confirm" style="margin-left: 24px;" @click="confirmRecharge">确认充值</el-button>
          </el-tooltip>
        </span>
      </el-dialog>
    </div>

    <!-- 驳回弹窗 -->
    <div class="public-dialog">
      <el-dialog
        title="驳回交易流水"
        :visible.sync="rejectModal.visible"
        width="500px"
        :closeOnClickModal="false"
        append-to-body
        @close="rejectModalClose"
      >
        <div class="recharge-info-box">
          <div class="rr-info-section-title">交易信息</div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">流水号：</span>
            <span class="recharge-info-value">{{ rejectModal.row.ORMTB433CA00 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">交易时间：</span>
            <span class="recharge-info-value">{{ rejectModal.row.ORMTB433CA02 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">付款人名称：</span>
            <span class="recharge-info-value">{{ rejectModal.row.ORMTB433CA04 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">付款人账号：</span>
            <span class="recharge-info-value">{{ rejectModal.row.ORMTB433CA03 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">交易金额：</span>
            <span class="recharge-info-value" style="color: #f56c6c; font-weight: bold; font-size: 16px;">
              {{ formatAmount(rejectModal.row.ORMTB433CA05) }}
            </span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">识别码：</span>
            <span class="recharge-info-value">{{ rejectModal.row.ORMTB433CA12 }}</span>
          </div>
          <div class="rr-info-section-title rr-info-section-title-receive">收款信息</div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">收款户名：</span>
            <span class="recharge-info-value">{{ rejectModal.row.ORMTB433CA11 }}</span>
          </div>
          <div class="recharge-info-item">
            <span class="recharge-info-label">收款账号：</span>
            <span class="recharge-info-value">{{ rejectModal.row.ORMTB433CA10 }}</span>
          </div>
        </div>
        <div class="recharge-remark-box">
          <div class="recharge-info-label" style="margin-bottom: 8px;">驳回原因：</div>
          <el-input
            v-model="rejectModal.reason"
            type="textarea"
            :rows="3"
            placeholder="请输入驳回原因"
            maxlength="200"
            show-word-limit
          ></el-input>
        </div>
        <span slot="footer">
          <el-button @click="rejectModal.visible = false">取消</el-button>
          <el-button type="danger" :loading="rejectModal.loading" style="margin-left: 24px;" @click="rejectRecharge">确认驳回</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 详情弹窗 -->
    <div class="public-dialog">
      <el-dialog
        title="交易流水详情"
        :visible.sync="detailModal.visible"
        width="620px"
        :closeOnClickModal="false"
        append-to-body
        custom-class="rr-detail-dialog"
        @close="detailModalClose"
      >
        <div v-loading="detailModal.loading">
          <!-- 交易信息 -->
          <div class="recharge-detail-section">
            <div class="recharge-detail-title">交易信息</div>
            <div class="recharge-detail-grid">
              <div class="recharge-info-item">
                <span class="recharge-info-label">交易时间：</span>
                <span class="recharge-info-value">{{ detailModal.record.ORMTB433CA02 }}</span>
              </div>
              <div class="recharge-info-item">
                <span class="recharge-info-label">付款人名称：</span>
                <span class="recharge-info-value">{{ detailModal.record.ORMTB433CA04 }}</span>
              </div>
              <div class="recharge-info-item">
                <span class="recharge-info-label">付款人账号：</span>
                <span class="recharge-info-value">{{ detailModal.record.ORMTB433CA03 }}</span>
              </div>
              <div class="recharge-info-item">
                <span class="recharge-info-label">交易金额：</span>
                <span class="recharge-info-value" style="color: #f56c6c; font-weight: bold;">
                  ¥ {{ formatAmount(detailModal.record.ORMTB433CA05) }}
                </span>
              </div>
              
             
              <div class="recharge-info-item">
                <span class="recharge-info-label">识别码：</span>
                <span class="recharge-info-value">{{ detailModal.record.ORMTB433CA12 }}</span>
              </div>
              <div class="recharge-info-item">
                <span class="recharge-info-label">状态：</span>
                <span class="recharge-info-value">
                  <el-tag :type="statusTagType(detailModal.record.ORMTB433CA13)" size="small">
                    {{ statusLabel(detailModal.record.ORMTB433CA13) }}
                  </el-tag>
                </span>
              </div>
            </div>
          </div>

          <!-- 收款信息 -->
          <div class="recharge-detail-section">
            <div class="recharge-detail-title">收款信息</div>
            <div class="recharge-detail-grid">
				<div class="recharge-info-item">
				  <span class="recharge-info-label">收款户名：</span>
				  <span class="recharge-info-value">{{ detailModal.record.ORMTB433CA11 }}</span>
				</div>
              <div class="recharge-info-item">
                <span class="recharge-info-label">收款账号：</span>
                <span class="recharge-info-value">{{ detailModal.record.ORMTB433CA10 }}</span>
              </div>
            </div>
          </div>

          <!-- 操作日志 -->
          <div class="recharge-detail-section" v-if="detailModal.logs && detailModal.logs.length > 0">
            <div class="recharge-detail-title" style="display: flex; justify-content: space-between; align-items: center;">
              <span>操作日志</span>
              <!-- <el-button type="text" size="small" @click="openLogModal(detailModal.record.id)">查看全部</el-button> -->
            </div>
            <el-table
              :data="detailModal.logs.slice(0, 5)"
              size="small"
              stripe
              class="public_tableColumn"
              :header-cell-style="{ color: 'rgba(51,51,51,1)', 'font-weight': 'bold' }"
            >
              <el-table-column prop="operatorName" label="操作人" width="90"></el-table-column>
              <el-table-column prop="operationType" label="操作类型" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.operationType === 'auto_charge' ? 'info' : 'success'" size="mini">
                    {{ scope.row.operationType === 'auto_charge' ? '自动处理' : '手动充值' }}
                  </el-tag>
                </template>
				
              </el-table-column>
              <el-table-column prop="operationTime" label="操作时间" width="150"></el-table-column>
              <el-table-column prop="operationContent" label="操作内容" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </div>
        <div slot="footer" style="display: flex; justify-content: center; width: 100%;">
          <el-button type="primary" @click="detailModal.visible = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 操作日志弹窗 -->
    <div class="public-dialog">
      <el-dialog
        title="操作日志"
        :visible.sync="logModal.visible"
        width="700px"
        :closeOnClickModal="false"
        append-to-body
      >
        <div v-loading="logModal.loading">
          <el-table
            :data="logModal.list"
            size="small"
            stripe
            class="public_tableColumn"
            :header-cell-style="{
              color: 'rgba(51,51,51,1)',
              background: 'rgba(184,227,255,1)',
              'font-weight': 'bold',
            }"
          >
            <el-table-column prop="operatorName" label="操作人" width="100" align="center"></el-table-column>
            <el-table-column prop="operationType" label="操作类型" width="120" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.operationType === 'auto_charge' ? 'info' : 'success'" size="small">
                  {{ scope.row.operationType === 'auto_charge' ? '自动处理' : '手动充值' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="operationTime" label="操作时间" width="160" align="center"></el-table-column>
            <el-table-column prop="operationContent" label="操作内容" show-overflow-tooltip></el-table-column>
          </el-table>
          <div class="pulbic_pagesize">
            <el-pagination
              @size-change="logSizeChange"
              @current-change="logCurrentChange"
              :current-page.sync="logModal.page"
              :page-sizes="[5, 10, 20]"
              :page-size="logModal.limit"
              layout="total, sizes, prev, pager, next"
              :total="logModal.total"
            ></el-pagination>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="logModal.visible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DateRangePicker from '@/components/common/DateRangePicker.vue'

export default {
  name: 'RechargeReconciliation',
  components: { DateRangePicker },
  data() {
    return {
      dateRange: [],
      queryParams: {
        ORMTB410ID: '',      // 客户ID
        ORMTB433CA04: '',    // 交易对手户名
        ORMTB433CA12: '',    // 备注(识别码)
        ORMTB433CA13: '',    // 状态
        startTime: '',
        endTime: '',
        page: 1,
        limit: 20,
      },
      statusOptions: [
        { label: '全部', value: '' },
        { label: '未处理', value: '0' },
        { label: '已处理', value: '1' },
        { label: '已驳回', value: '2' },
      ],

      tableData: [],
      total: 0,
      loadingBut: false,
      confirmTxt: '',
      rechargeCustomerOptions: [],
      filteredQueryCustomerOptions: [],
      filteredRechargeCustomerOptions: [],

      confirmModal: {
        visible: false,
        row: {},
        customerId: '',
        remark: '',
        loading: false,
      },

      rejectModal: {
        visible: false,
        row: {},
        reason: '',
        loading: false,
      },

      detailModal: {
        visible: false,
        loading: false,
        record: {},
        logs: [],
      },

      logModal: {
        visible: false,
        loading: false,
        rechargeId: null,
        list: [],
        total: 0,
        page: 1,
        limit: 10,
      },
    }
  },
  created() {
    this.getRechargeCustomerOptions()
  },
  mounted() {
    this.pageList()
  },
  methods: {
    formatAmount(val) {
      if (val == null || val === '') return '0.00'
      return Number(val).toFixed(2)
    },

    statusLabel(val) {
      const map = { '0': '未处理', '1': '已处理', '2': '已驳回' }
      return map[String(val)] || '-'
    },

    statusTagType(val) {
      const map = { '0': 'warning', '1': 'success', '2': 'danger' }
      return map[String(val)] || 'info'
    },

    customerOptionLabel(item) {
      if (!item) return ''
      const name = item.ORMTB410CA00 || item.ORMTB410NAME || ''
      const phone = item.ORMTB410CA02 || ''
      return phone ? `${name} / ${phone}` : name
    },

    getRechargeCustomerOptions() {
      var postData = {}
      if (this.$store.state.uobj && this.$store.state.uobj.pertb005 && this.$store.state.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        postData = { ORMTB400ID: this.$store.state.uobj.ormtb410.ORMTB410ID }
      }
      if (this.$store.state.uobj && this.$store.state.uobj.pertb005 && this.$store.state.uobj.pertb005.pertb005cb00 == 'CUS-1') {
        postData = { ORMTB400ID: this.$store.state.uobj.ormtb400.ORMTB400ID }
      }
      this.axios.post('/orm/ormtb410/selectOrmtb410s', postData).then(res => {
        if (res.data.code == 200) {
          this.rechargeCustomerOptions = res.data.data || []
          this.filteredQueryCustomerOptions = this.rechargeCustomerOptions.slice(0, 100)
          this.filteredRechargeCustomerOptions = this.rechargeCustomerOptions.slice(0, 100)
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      })
    },

    filterCustomerOptions(query) {
      if (!query) {
        return this.rechargeCustomerOptions.slice(0, 100)
      }
      const q = query.toLowerCase().trim()
      const segments = q.match(/[一-龥]+|[a-z0-9]+/g) || [q]
      return this.rechargeCustomerOptions.filter(item => {
        const name = (item.ORMTB410CA00 || item.ORMTB410NAME || '').toLowerCase()
        const phone = (item.ORMTB410CA02 || '').toLowerCase()
        const pinyin = (item.ORMTB410CA13 || '').toLowerCase()
        return segments.every(seg => {
          if (/[一-龥]/.test(seg)) {
            return name.includes(seg)
          }
          return pinyin.includes(seg) || phone.includes(seg) || name.includes(seg)
        })
      })
    },

    filterQueryCustomer(query) {
      this.filteredQueryCustomerOptions = this.filterCustomerOptions(query)
    },

    filterRechargeCustomer(query) {
      this.filteredRechargeCustomerOptions = this.filterCustomerOptions(query)
    },

    queryClick() {
      this.queryParams.page = 1
      this.pageList()
    },

    resetQuery() {
      this.queryParams = { ORMTB410ID: '', ORMTB433CA04: '', ORMTB433CA12: '', ORMTB433CA13: '', startTime: '', endTime: '', page: 1, limit: 20 }
      this.filterQueryCustomer('')
      if (this.$refs.dateRangePicker) {
        this.$refs.dateRangePicker.setNowDay()
      } else {
        this.getNowDay()
      }
      this.pageList()
    },

    getNowDay() {
      const date = new Date()
      const pad = val => String(val).padStart(2, '0')
      const today = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
      this.dateRange = [today + ' 00:00:00', today + ' 23:59:59']
    },

    exportExcel() {
      this.$confirm('此操作将会导出该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        var startTime = this.dateRange && this.dateRange[0] ? this.dateRange[0] : ''
        var endTime = this.dateRange && this.dateRange[1] ? this.dateRange[1] : ''
        var ORMTB410ID = this.queryParams.ORMTB410ID || ''
        var ORMTB433CA04 = this.queryParams.ORMTB433CA04 || ''
        var ORMTB433CA12 = this.queryParams.ORMTB433CA12 || ''
        var ORMTB433CA13 = this.queryParams.ORMTB433CA13 || ''
        var url = this.axios.defaults.baseURL + '/exc/toExcel/ormtb433toExcle?startTime=' + encodeURIComponent(startTime) +
          '&endTime=' + encodeURIComponent(endTime) +
          '&ORMTB410ID=' + encodeURIComponent(ORMTB410ID) +
          '&ORMTB433CA04=' + encodeURIComponent(ORMTB433CA04) +
          '&ORMTB433CA12=' + encodeURIComponent(ORMTB433CA12) +
          '&ORMTB433CA13=' + encodeURIComponent(ORMTB433CA13)
        window.location.href = url
        this.loadingBut = true
        var timer = null
        this.confirmTxt = 30 - 1
        timer = setInterval(() => {
          if (this.confirmTxt === 0) {
            this.confirmTxt = ''
            this.loadingBut = false
            clearInterval(timer)
          } else {
            this.confirmTxt--
          }
        }, 1000)
      })
    },

    pageList() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        startTime: this.dateRange && this.dateRange[0] ? this.dateRange[0] : '',
        endTime: this.dateRange && this.dateRange[1] ? this.dateRange[1] : '',
        ORMTB410ID: this.queryParams.ORMTB410ID,
        ORMTB433CA04: this.queryParams.ORMTB433CA04,
        ORMTB433CA12: this.queryParams.ORMTB433CA12,
        ORMTB433CA13: this.queryParams.ORMTB433CA13,
        page: this.queryParams.page,
        limit: this.queryParams.limit,
      }
      this.tableData = []
      this.axios.post('/orm/ormtb433/selectPageList', postData).then(res => {
        loading.close()
        if (res.data.code == 200) {
          this.tableData = res.data.data || []
          this.total = res.data.count || 0
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      }).catch(() => {
        loading.close()
        this.$message({ message: '请求失败，请重试', type: 'error' })
      })
    },

    handleSizeChange(val) {
      this.queryParams.limit = val
      this.queryParams.page = 1
      this.pageList()
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.pageList()
    },

    openConfirmModal(row) {
      this.confirmModal.row = JSON.parse(JSON.stringify(row))
      this.confirmModal.customerId = row.ORMTB410ID || ''
      this.confirmModal.remark = ''
      this.confirmModal.visible = true
    },
    confirmModalClose() {
      this.confirmModal.row = {}
      this.confirmModal.customerId = ''
      this.confirmModal.remark = ''
    },

    confirmRecharge() {
      if (!this.confirmModal.row.ORMTB433ID) {
        this.$message({ message: '数据异常，请刷新后重试', type: 'error' })
        return
      }
      if (!this.confirmModal.customerId) {
        this.$message({ message: '请选择要充值的客户', type: 'warning' })
        return
      }
      this.confirmModal.loading = true
      var postData = {
        ORMTB433ID: this.confirmModal.row.ORMTB433ID,
        ORMTB410ID: this.confirmModal.customerId,
        ORMTB420CB01: this.confirmModal.remark,
      }
      this.axios.post('/orm/ormtb411/cz', postData).then(res => {
        this.confirmModal.loading = false
        if (res.data.code == 200) {
          this.$message({ message: res.data.message, type: 'success' })
          this.confirmModal.visible = false
          this.pageList()
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      }).catch(() => {
        this.confirmModal.loading = false
        this.$message({ message: '请求失败，请重试', type: 'error' })
      })
    },

    openRejectModal(row) {
      this.rejectModal.row = JSON.parse(JSON.stringify(row))
      this.rejectModal.reason = ''
      this.rejectModal.visible = true
    },
    rejectModalClose() {
      this.rejectModal.row = {}
      this.rejectModal.reason = ''
    },
    rejectRecharge() {
      if (!this.rejectModal.row.ORMTB433ID) {
        this.$message({ message: '数据异常，请刷新后重试', type: 'error' })
        return
      }
      if (!this.rejectModal.reason) {
        this.$message({ message: '请输入驳回原因', type: 'warning' })
        return
      }
      this.rejectModal.loading = true
      var postData = {
        ORMTB433ID: this.rejectModal.row.ORMTB433ID,
        ORMTB433CA18: this.rejectModal.reason,
      }
      this.axios.post('/orm/ormtb433/cancel', postData).then(res => {
        this.rejectModal.loading = false
        if (res.data.code == 200) {
          this.$message({ message: res.data.message, type: 'success' })
          this.rejectModal.visible = false
          this.pageList()
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      }).catch(() => {
        this.rejectModal.loading = false
        this.$message({ message: '请求失败，请重试', type: 'error' })
      })
    },

    openDetailModal(row) {
      this.detailModal.record = row
      this.detailModal.logs = []
      // this.detailModal.loading = true
      this.detailModal.visible = true
      // this.axios.post('/orm/ormtb433/selectOrmtb433Detail', { id: row.id }).then(res => {
      //   this.detailModal.loading = false
      //   if (res.data.code == 200) {
      //     this.detailModal.record = res.data.data.record || {}
      //     this.detailModal.logs = res.data.data.operationLogs || []
      //   } else {
      //     this.$message({ message: res.data.message, type: 'error' })
      //   }
      // }).catch(() => {
      //   this.detailModal.loading = false
      //   this.$message({ message: '请求失败，请重试', type: 'error' })
      // })
    },
    detailModalClose() {
      this.detailModal.record = {}
      this.detailModal.logs = []
    },

    openLogModal(id) {
      this.logModal.rechargeId = id
      this.logModal.page = 1
      this.logModal.list = []
      this.logModal.visible = true
      this.fetchLogs()
    },
    fetchLogs() {
      this.logModal.loading = true
      this.axios.post('/orm/ormtb433/selectOperationLogs', {
        id: this.logModal.rechargeId,
        page: this.logModal.page,
        limit: this.logModal.limit,
      }).then(res => {
        this.logModal.loading = false
        if (res.data.code == 200) {
          this.logModal.list = res.data.data.records || []
          this.logModal.total = res.data.data.total || 0
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      }).catch(() => {
        this.logModal.loading = false
        this.$message({ message: '请求失败，请重试', type: 'error' })
      })
    },
    logSizeChange(val) {
      this.logModal.limit = val
      this.logModal.page = 1
      this.fetchLogs()
    },
    logCurrentChange(val) {
      this.logModal.page = val
      this.fetchLogs()
    },
  },
}
</script>

<style scoped>
/* ===== 页面整体 ===== */
.rr-page {
  min-height: 100%;
  background: linear-gradient(180deg, #edf4ff 0%, #f5f8fc 44%, #f7f9fc 100%);
}

/* ===== 页面头部 ===== */
.rr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  margin-bottom: 14px;
  border: 1px solid rgba(210, 224, 245, 0.88);
  border-radius: 16px;
  background: radial-gradient(circle at 86% 12%, rgba(64,158,255,0.12), transparent 30%),
              linear-gradient(135deg, rgba(255,255,255,0.98), rgba(236,246,255,0.94));
  box-shadow: 0 8px 24px rgba(35, 69, 113, 0.07);
}

.rr-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.rr-header-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #e8f4ff, #d0e8ff);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rr-header-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a2e45;
  letter-spacing: 0.5px;
}

.rr-header-desc {
  font-size: 13px;
  color: #7a8da0;
  margin-top: 3px;
}

.rr-header-stats {
  display: flex;
  gap: 20px;
}

.rr-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 18px;
  border-radius: 10px;
  background: rgba(64,158,255,0.07);
  border: 1px solid rgba(64,158,255,0.15);
}

.rr-stat-pending {
  background: rgba(230,162,60,0.08);
  border-color: rgba(230,162,60,0.2);
}

.rr-stat-num {
  font-size: 22px;
  font-weight: 700;
  color: #409EFF;
  line-height: 1;
}

.rr-stat-pending .rr-stat-num {
  color: #e6a23c;
}

.rr-stat-label {
  font-size: 12px;
  color: #7a8da0;
  margin-top: 4px;
}

/* ===== 筛选区 ===== */
.rr-filter-card {
  margin-bottom: 14px;
}

.rr-filter-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #edf2f8;
}

.rr-filter-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a2e45;
}

.rr-filter-desc {
  font-size: 12px;
  color: #9aaec0;
}

.rr-customer-filter-select {
  width: 320px;
}

/* ===== 表格区头部 ===== */
.rr-table-card {
  padding-top: 0 !important;
}

.rr-table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px 12px;
  border-bottom: 1px solid #edf2f8;
}

.rr-table-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rr-table-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rr-table-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a2e45;
}

.rr-table-subtitle {
  font-size: 12px;
  color: #9aaec0;
  margin-top: 2px;
}

.rr-status-legend {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 12px;
  color: #7a8da0;
}

.rr-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: middle;
}

.rr-dot-pending { background: #e6a23c; }
.rr-dot-done    { background: #67c23a; }
.rr-dot-reject  { background: #f56c6c; }

/* ===== 表格内容 ===== */
.rr-serial-no {
  font-size: 14px;
  font-weight: 600;
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
  letter-spacing: 0.3px;
}

.rr-serial-no:hover {
  color: #66b1ff;
}

.rr-trade-time {
  color: #777;
  font-size: 12px;
  margin-top: 3px;
}

.rr-customer-name {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.rr-customer-phone {
  color: #409EFF;
  font-size: 13px;
  font-weight: 500;
  margin-top: 3px;
}

.rr-customer-empty {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  background: #fff7e6;
  color: #e6a23c;
  font-size: 13px;
  font-weight: 600;
}

.rr-amount {
  color: #f56c6c;
  font-weight: 700;
  font-size: 14px;
}

.rr-processed-tip {
  font-size: 13px;
  color: #aaa;
}

/* ===== 弹窗信息区 ===== */
.recharge-info-box {
  background: #f8fafd;
  border: 1px solid #e4ecf7;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.rr-info-section-title {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  margin-bottom: 12px;
  border-radius: 12px;
  background: #ecf5ff;
  color: #409EFF;
  font-size: 14px;
  font-weight: 700;
}

.rr-info-section-title::before {
  content: '';
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
  background: #409EFF;
}

.rr-info-section-title-receive {
  margin-top: 12px;
  background: #f0f9eb;
  color: #67c23a;
}

.rr-info-section-title-receive::before {
  background: #67c23a;
}

.recharge-customer-box {
  padding: 0 2px;
  margin-bottom: 16px;
}

.recharge-customer-tip {
  display: inline-block;
  margin-top: 8px;
  padding: 5px 10px;
  border-radius: 12px;
  background: #ecf5ff;
  color: #409EFF;
  font-size: 13px;
  font-weight: 600;
}

.recharge-remark-box {
  padding: 0 2px;
}

.rr-remark-title {
  font-size: 15px;
  color: #303133;
  font-weight: 700;
  margin-bottom: 10px;
  padding-left: 8px;
  border-left: 3px solid #409EFF;
}

.recharge-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.6;
}

.recharge-info-label {
  width: 110px;
  color: #555;
  flex-shrink: 0;
  font-weight: 600;
}

.recharge-info-value {
  flex: 1;
  color: #1a1a1a;
  word-break: break-all;
  font-weight: 500;
}

/* ===== 详情弹窗分区 ===== */
.recharge-detail-section {
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #ebeef5;
}

.recharge-detail-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.recharge-detail-title {
  font-size: 13px;
  font-weight: 700;
  color: #409EFF;
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 3px solid #409EFF;
}

.recharge-detail-grid {
  padding-left: 4px;
}

/* ===== 弹窗底部按钮 ===== */
/deep/ .rr-detail-dialog .el-dialog__footer {
  text-align: center !important;
}

.rr-dialog-footer-center {
  display: block;
  text-align: center;
}

.rr-btn-cancel {
  min-width: 80px;
  transition: all 0.2s;
}

.rr-btn-cancel:hover {
  background: #fff0f0;
  border-color: #f56c6c;
  color: #f56c6c;
}

.rr-btn-confirm {
  min-width: 100px;
  transition: all 0.2s;
}

.rr-btn-confirm:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

/* ===== 高分屏/大分辨率性能降级 ===== */
@media screen and (min-width: 1920px) {
  .rr-page {
    background: #f5f8fc;
  }

  .rr-header {
    background: #fff;
    box-shadow: none;
  }

  .rr-header-icon,
  .rr-table-icon {
    background: #ecf5ff;
  }

  .rr-stat-item,
  .rr-filter-card,
  .rr-table-card,
  .recharge-info-box {
    box-shadow: none !important;
  }

  .rr-serial-no,
  .rr-btn-cancel,
  .rr-btn-confirm,
  .pulbic_oparetionBlock,
  .pulbic_table_container {
    transition: none !important;
  }

  .rr-btn-confirm:hover {
    transform: none;
    box-shadow: none;
  }
}
</style>
